import React from 'react';
import { AttendeeInfo } from '../../../types';
import Card from '../../ui/Card/Card';
import styles from './TicketReceipt.module.css';

interface TicketReceiptProps {
  attendees: AttendeeInfo[];
  totalPrice: number;
  getTranslation: (key: string) => string;
}

const TicketReceipt: React.FC<TicketReceiptProps> = ({
  attendees,
  totalPrice,
  getTranslation
}) => {
  // Group attendees by ticket type
  const groupedByTicket = attendees.reduce((acc, attendee) => {
    const key = attendee.ticketID;
    if (!acc[key]) {
      acc[key] = {
        ticketTitle: attendee.ticketTitle,
        ticketPrice: attendee.ticketPrice,
        count: 0,
        attendees: []
      };
    }
    acc[key].count++;
    acc[key].attendees.push(attendee);
    return acc;
  }, {} as Record<string, { ticketTitle: string; ticketPrice: number; count: number; attendees: AttendeeInfo[] }>);

  const formatPrice = (price: number | string) => {
    const numericPrice = typeof price === 'string' ? parseFloat(price) : Number(price);
    if (isNaN(numericPrice) || numericPrice === 0 || Math.abs(numericPrice) < 0.01) {
      return getTranslation('events.free');
    }
    return `${numericPrice.toLocaleString('en-US')} TL`;
  };

  return (
    <Card className={styles.receiptCard}>
      <h3 className={styles.receiptTitle}>{getTranslation('events.orderSummary')}</h3>
      
      <div className={styles.ticketsList}>
        {Object.entries(groupedByTicket).map(([ticketID, group]) => (
          <div key={ticketID} className={styles.ticketGroup}>
            <div className={styles.ticketHeader}>
              <span className={styles.ticketName}>{group.ticketTitle}</span>
              <span className={styles.ticketCount}>×{group.count}</span>
            </div>
            <div className={styles.ticketPrice}>
              {formatPrice(group.ticketPrice)} × {group.count} = {formatPrice(group.ticketPrice * group.count)}
            </div>
          </div>
        ))}
      </div>

      <div className={styles.totalSection}>
        <div className={styles.totalRow}>
          <span className={styles.totalLabel}>{getTranslation('events.total')}:</span>
          <span className={styles.totalAmount}>{formatPrice(totalPrice)}</span>
        </div>
        <div className={styles.participantsCount}>
          {getTranslation('events.totalParticipants')}: {attendees.length}
        </div>
      </div>
    </Card>
  );
};

export default TicketReceipt;

